<app-de-wrapper *ngIf="!loading">
  <ng-container>
    <iframe
      *ngIf="useIframe"
      class="iframe"
      scrolling="yes"
      [src]="trustlyUrl"
    ></iframe>
  </ng-container>
</app-de-wrapper>

<app-de-wrapper *ngIf="loading">
  <app-spinner></app-spinner>
</app-de-wrapper>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="toggleModal()"
>
  <app-selector #selector [selectorItems]="selectorItems"></app-selector>
</zaver-checkout-modal>
